import React from 'react';

const CalendarIcon = ({ size = 24, color = '#000' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66602 1.66663V4.16663"
        stroke="#CCD2E3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.334 1.66663V4.16663"
        stroke="#CCD2E3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.91602 7.57495H17.0827"
        stroke={color}
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3327 15.8333C18.3327 16.4583 18.1577 17.05 17.8493 17.55C17.2743 18.5167 16.216 19.1667 14.9993 19.1667C14.1577 19.1667 13.391 18.8583 12.8077 18.3333C12.5494 18.1167 12.3244 17.85 12.1494 17.55C11.841 17.05 11.666 16.4583 11.666 15.8333C11.666 13.9917 13.1577 12.5 14.9993 12.5C15.9993 12.5 16.891 12.9417 17.4993 13.6333C18.016 14.225 18.3327 14.9917 18.3327 15.8333Z"
        stroke="#CCD2E3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.6992 15.8333L14.5242 16.6583L16.2992 15.0166"
        stroke="#CCD2E3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 7.08329V13.6333C16.8917 12.9416 16 12.5 15 12.5C13.1583 12.5 11.6667 13.9916 11.6667 15.8333C11.6667 16.4583 11.8417 17.05 12.15 17.55C12.325 17.85 12.55 18.1166 12.8083 18.3333H6.66667C3.75 18.3333 2.5 16.6666 2.5 14.1666V7.08329C2.5 4.58329 3.75 2.91663 6.66667 2.91663H13.3333C16.25 2.91663 17.5 4.58329 17.5 7.08329Z"
        stroke="#CCD2E3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99607 11.4167H10.0036"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.91209 11.4167H6.91957"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.91211 13.9166H6.91959"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CalendarIcon;
